import React from 'react';
import { avatarImageUrl, getStudentAvatar } from '../../shared/studentAvatar';

export default function StudentPointAvatar({ student, large = false, imageSize = 128 }) {
  const theme = getStudentAvatar(student.student_id, student.avatar_id, student.starter_emoji);
  return <span className={`ap-student-avatar${large ? ' is-large' : ''}`} style={{ background: theme.bgColor, borderColor: theme.borderColor }} aria-hidden="true">
    {theme.imageUrl ? <img src={avatarImageUrl(student.avatar_id, imageSize)} alt="" loading="lazy" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : theme.avatar}
  </span>;
}
